export default "__VITE_ASSET__C$iX540e__"